// ChatStart.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import _ from 'lodash';

import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import getChatStartListSelectPath from '../selector/getChatStartListSelectPath.js';
import fetchUserSearch from '../action/fetchUserSearch.js';
import setChatroomUserDiscover from '../action/setChatroomUserDiscover.js';
import subscribeFeedChannel from '../action/subscribeFeedChannel.js';
import unsubscribeFeedChannel from '../action/unsubscribeFeedChannel.js';
import getMeData from '../selector/getMeData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';

import ChatStart from '../page/ChatStart.jsx';
import { breakpoint } from '../style/variables.js';

const mapStateToProps = state => {
  const query =
    getOperationData(state, ['chatroom', 'discover'], 'query') || '';
  const swaggerOnlineFeed = getOperationData(
    state,
    ['swaggerOnlineFeed'],
    'search'
  );
  const swaggerNewFeed = getOperationData(state, ['swaggerNewFeed'], 'search');
  const category =
    getOperationData(state, ['chatroom', 'discover'], 'category') ||
    swaggerOnlineFeed;

  const listSelectPath = getChatStartListSelectPath(state, query, category);
  const isFirstPageFetching = getNetworkingData(
    state,
    [...listSelectPath, 'firstPage'],
    'isFetching'
  );

  const isAuthed = !!getMeData(state, 'id');
  const isRemoteConfigMerged = isAuthed
    ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
    : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT) ||
      getIsRemoteConfigMerged(state, CONFIG_PRIORITY_CONFIGURE);
  const deviceWidth = getOperationData(state, ['device'], 'width');

  const isOnDesktop = deviceWidth > breakpoint.mobile;

  return {
    query,
    category,
    listSelectPath,
    isFirstPageFetching,
    itemIds: getListData(state, listSelectPath, 'itemIds'),
    isRemoteConfigMerged,
    isOnDesktop,
    swaggerOnlineFeed,
    swaggerNewFeed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setUserDiscoverCategory: category =>
      dispatch(setChatroomUserDiscover({ category })),
    setUserDiscoverQuery: query => dispatch(setChatroomUserDiscover({ query })),
    searchUsers: _.debounce(
      conditions =>
        dispatch(
          fetchUserSearch({
            ...conditions,
            selectPath: ['chatroom', 'user', 'query', conditions.query],
          })
        ),
      500
    ),
    goBack: () => dispatch(goBack()),
    subscribeFeedChannel: ({ feedName }) =>
      dispatch(subscribeFeedChannel({ feedName })),
    unsubscribeFeedChannel: ({ feedName }) =>
      dispatch(unsubscribeFeedChannel({ feedName })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatStart);
